<div *ngIf="title" mat-dialog-title class="title">
  {{ title }}
</div>
<mat-dialog-content class="common-lib-dialog">
  <div class="text-1">
    <div class="message" [innerText]="message"></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="common-lib-dialog">
  <button mat-flat-button class="btn-ok" (click)="close('agree')">Agree</button>
  <button mat-button mat-dialog-close class="btn-cancel" (click)="close('logout')">Logout</button>
</mat-dialog-actions>
